import { CommitmentResponse } from './commitment';
import { commitmentRes } from './dummyCommitmentResdata';

/**
 * This method is to get all the commitments
 * @param agentId -  unique id of agent
 * @example
 * ```
 * getCommitments(1464319);
 * ```
 */
export class CommitmentService {
  /**
   * This method is to get all the commitments
   * @param agentId -  unique id of agent
   * @example
   * ```
   * getCommitments(1464319);
   * ```
   */
  getCommitments(agentId: number): Promise<CommitmentResponse[]> {
    return new Promise((resolve, reject) => {
      resolve(commitmentRes);
    });
  }

  
}
